import { useT } from "@/contexts/I18nContext";
import { ZONE } from "@/services/zone";

/**
 * Which deployment this console is acting on.
 *
 * On every screen, from the first day, when there is only one zone and the
 * answer is always EU. It exists now precisely because it will not always be:
 * the moment there are two, the question "which one am I looking at?" has to
 * already have an answer in the place people are used to looking, rather than
 * becoming a new thing to learn on the day it starts to matter.
 */
export function ZoneBadge() {
  const t = useT();
  return (
    <span
      title={t("zone.explain")}
      className="rounded border border-paper-deep bg-paper-warm px-2 py-1 text-xs font-medium text-ink-soft"
    >
      {t("zone.label")}
      <span className="ml-1.5 text-ink">{t(`zone.${ZONE}`)}</span>
    </span>
  );
}
